import {camelCase} from "lodash";
import i18n from "i18n/i18n"

export const optionsTranslation = (key: string, value: string) => {
  const camelCaseKey = camelCase(key)
  const camelCaseValue = camelCase(value)

  return value ? i18n.t(`options.${camelCaseKey}.${camelCaseValue}`) : ''
}
